// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"72":"0b7b90cd","624":"fb7d5399","906":"9307c911"}[chunkId] || chunkId) + "." + {"50":"adf74b5628718c44","72":"dc0104c580feac4e","445":"2fe0cac5dc811272","624":"c9161ef97f58ea53","906":"bfcc6c34f7923149"}[chunkId] + ".js";
};